import 'react-dates/initialize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'clsx';

import { ColorService } from '../../services/color-service';
import { DropdownMenu } from '../dropdown-menu';
import { DropdownMenuItem } from '../dropdown-menu-item';
import { DropdownMenuToggler } from '../dropdown-menu-toggler';

import style from './color-picker.module.less';
import type { ColorPickerComponent } from './color-picker-types';

const BLACK = '#000000';

const WHITE = '#FFFFFF';

/**
 * @deprecated Use `ColorPicker` or `ColorInput` from `@mantine/core` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 */
export const ColorPicker: ColorPickerComponent = ({
  value,
  colors,
  isCompact = false,
  compactIcon,
  className = '',
  buttonClassName = '',
  onChange,
  menuPosition = 'bottom-left',
  dropdownMenuType,
  id,
}) => {
  const selectedColorStyle = { background: value };
  const iconStyle = {
    color: ColorService.shouldUseWhiteText(value) ? WHITE : BLACK,
  };
  return (
    <DropdownMenu
      className={className}
      dropdownMenuClassName={style['dropdown-menu']}
      dropdownMenuType={dropdownMenuType}
      id={id}
      menuPosition={menuPosition}
    >
      <DropdownMenuToggler
        className={classnames(
          {
            [style['dropdown-toggler-compact']]: isCompact,
          },
          buttonClassName,
        )}
        hideChevron={isCompact}
      >
        <div
          className={classnames(style['dropdown-toggler-color'], {
            [style['dropdown-toggler-color-compact']]: isCompact,
          })}
          style={selectedColorStyle}
        >
          {compactIcon ? (
            <div className={style['compact-icon-container']} style={iconStyle}>
              <FontAwesomeIcon className={style['compact-icon']} icon={compactIcon} />
            </div>
          ) : null}
        </div>
      </DropdownMenuToggler>
      <DropdownMenuItem>
        <div className={style['colors-wrapper']}>
          {colors.map((color) => {
            const colorStyle = {
              background: color,
            };
            const classes = classnames(style['color-button'], {
              [style.selected]: color === value,
              [style['show-border']]: color.toUpperCase() === '#FFF' || color.toUpperCase() === '#FFFFFF',
            });

            return (
              <div key={color} className={style['color-button-wrapper']}>
                <div
                  className={classes}
                  onClick={() => onChange(color)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && e.target === document.activeElement) {
                      onChange(color);
                    }
                  }}
                  role='button' // oxlint-disable-line jsx-a11y/prefer-tag-over-role
                  style={colorStyle}
                  tabIndex={0}
                />
              </div>
            );
          })}
        </div>
      </DropdownMenuItem>
    </DropdownMenu>
  );
};
